import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { useEditor } from '../../../hooks/useEditor'

import { LinkCardContext } from './contexts/StoreContext'
import { createLinkCardStore } from './store/createStore'

export const LinkCardStoreProvider = ({ children }: PropsWithChildren) => {
  const editor = useEditor()

  const store = useCreation(() => createLinkCardStore({ editor }), [editor])

  return <LinkCardContext value={store}>{children}</LinkCardContext>
}
